import cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

import * as constants from '../constants/constants'

const getToken = () => cookies.get(constants.REACT_APP_AUTHENTICATE_TOKEN_NAME)

const deleteToken = () => {
    cookies.remove(constants.REACT_APP_AUTHENTICATE_TOKEN_NAME, {
        path: '/',
        domain: constants.REACT_APP_DOMAIN
    })
}

const readToken = (token) => {
    try {
        return jwtDecode(token)
    } catch (err) {
        deleteToken()
        window.location.replace('/login')
    }
}

const setToken = (token) => {
    cookies.set(constants.REACT_APP_AUTHENTICATE_TOKEN_NAME, token, {
        path: '/',
        domain: constants.REACT_APP_DOMAIN,
        expires: 2 * 365 * 24 * 60 * 60
    })
}

const setUserId = (token) => {
    cookies.set("USER_ID", token, {
        path: '/',
        domain: constants.REACT_APP_DOMAIN,
        expires: 2 * 365 * 24 * 60 * 60
    })
}

const getUserDetails = () => {
    try {
        const decoded = jwtDecode(getToken())
        return {
            userRoles: decoded?.Roles, userId: decoded.uam_id
        }
    } catch (error) {
        console.error('Error decoding token:', error)
        return {}
    }
}

const readUserId = () => cookies.get("USER_ID")

const isLoggedIn = () => Boolean(getToken())

const getUserId = () => readToken(getToken()).uam_id

const isRoleValid = (tokenInfo) => {
    if (!tokenInfo || !tokenInfo.roles) {
        return false
    }
    return true
}

const isValidUser = () => {
    if (!isLoggedIn()) {
        return false;
    }

    const token = getToken();
    const tokenInfo = readToken(token);

    if (!tokenInfo) {
        return false;
    }
    return true;
};


export default {
    getToken,
    setToken,
    deleteToken,
    getUserId,
    isValidUser,
    setUserId,
    readUserId,
    getUserDetails
}
